<template>
  <md-dialog
    :md-active.sync="isOpen"
    :md-backdrop="true"
    :md-fullscreen="true"
    :md-close-on-esc="true"
    v-on:md-closed="onClose"
  >
    <md-dialog-title>
      <div class="">
        <div>
          Order Details
        </div>
        <div v-if="current && current.vendResponse">
          <md-button
              class="md-block md-primary"
              @click="downloadReceiptPDF()"
          >{{ isLoading ? 'DOWNLOADING ... PLEASE WAIT' : 'DOWNLOAD RECEIPT PDF' }}</md-button
          >
        </div>
      </div>
    </md-dialog-title>

    <!-- State: Loading  -->
     <md-dialog-content v-if="loading">
      <!-- <loading-animation></loading-animation> -->
      <p>Getting Data...</p>
    </md-dialog-content>

     <md-dialog-content v-else-if="!loading && current">
      <!-- Fields -->
      <div>
        <div class="flex">
          <span>Reference</span> <span>{{ current.order_id }}</span>
        </div>
        <div class="flex">
          <span>Disco</span> <span>{{ current.disco_code }}</span>
        </div>
        <div class="flex">
          <span>Time</span> <span>{{ format(current.created_at) }}</span>
        </div>
        <div class="flex">
          <span>Asset Reference</span> <span>{{ current.meter_no }}</span>
        </div>
        <div class="flex">
          <span>Model</span> <span>{{ current.vend_type }}</span>
        </div>
        <div class="flex">
          <span>Vend Amount</span>
          <span>{{ formatAmount(current.vend_amount) }}</span>
        </div>
        <div class="flex">
          <span>Status</span> <span>{{ current.order_status }}</span>
        </div>
      </div>

      <!-- Vend Responses -->
      <h4>Response</h4>
      <md-divider></md-divider>
      <br />

      <!-- VendResponse: With Data -->
      <div v-if="current && current.vendResponse">
        <div v-if="current.vendResponse.token" class="flex">
          <span>Token</span>
          <span>{{ formatToken(current.vendResponse.token) || '' }}</span>
        </div>
        <div class="flex">
          <span>Receipt Number</span>
          <span>{{ current.vendResponse.rct_num }}</span>
        </div>
        <div class="flex">
          <span>Debt</span>
          <span>{{ formatAmount(current.vendResponse.debt_amt) }}</span>
        </div>
        <div class="flex">
          <span>VAT</span>
          <span>{{ formatAmount(current.vendResponse.tax) }}</span>
        </div>
      </div>

 <!-- VendResponse: Without Data -->
      <div v-else>
        <p>No response from service provider</p>
        <md-button
          class="md-block md-primary"
          @click="$emit('reQuery', current)"
          :disabled="isRequerying"
          >{{ isRequerying ? 'Requerying...' : 'Re-Query' }}</md-button
        >
      </div>

      <!-- Wallet Transations -->
      <h4>Wallet Transations</h4>
      <md-divider></md-divider>
      <br />
      <md-table table-header-color="green" v-if="current.walletTransactions.length">
        <md-table-row>
          <md-table-head>Amount (&#8358;)</md-table-head>
          <md-table-head>Type</md-table-head>
          <md-table-head>Date</md-table-head>
        </md-table-row>
        <md-table-row
          v-for="(walletTransaction, index) in current.walletTransactions"
          :key="index"
        >
          <md-table-cell md-label="Amount">
            {{ formatAmount(walletTransaction.amount) }}
          </md-table-cell>
          <md-table-cell md-label="Type">
            {{ walletTransaction.type }}
          </md-table-cell>
          <md-table-cell md-label="Date">
            {{ format(walletTransaction.created_at, 'DD/MM/YYYY hh:mm a') }}
          </md-table-cell>
        </md-table-row>
      </md-table>
       <p v-else>No data at the moment</p>
    </md-dialog-content>

    <!-- State: No data -->
    <md-dialog-content v-else-if="!loading && !current">
      Unable to load order.
    </md-dialog-content>

    <md-dialog-actions>
      <md-button @click="onClose()">Close</md-button>
    </md-dialog-actions>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </md-dialog>
</template>

<script>
import { siteUrl } from '@/utils/config';
import { format } from 'date-fns';
import html2pdf from 'html2pdf.js';
import {
  formatAmount,
  formatToken,
} from '../../utils/Formatter.util';
import { order } from '../../utils/template/order';

// import { LoadingAnimation } from '../components';

export default {
  name: 'order-modal',
  // components: LoadingAnimation,
  props: {
    current: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: Boolean,
    isRequerying: Boolean,
  },

  data() {
    return {
      isOpen: false,
      isLoading: false,
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    format,
    formatAmount,
    formatToken,
    onOpen() {
      this.isOpen = true;
    },
    onClose() {
      this.isOpen = false;
    },

    async downloadReceiptPDF() {
      try {
        const container = document.createElement('div');
        const address = this.current.address ? this.current.address.slice(0, 22) : '-------';
        container.innerHTML = order(this.current.name, address, this.current.convenience_fee, this.current.vendResponse.fixed, formatAmount(this.current.amount), formatToken(this.current.vendResponse.token), this.current.id, format(this.current.created_at, 'DD/MM/YYYY hh:mm a'), this.current.vendResponse.rct_num, this.current.vendResponse.meter, this.current.vendResponse.units, format(this.current.created_at, 'DD/MM/YYYY hh:mm a'), this.current.disco_code);
        document.body.appendChild(container);
        const options = {
          margin: [10, 10, 10, 10],
          filename: `${this.current.id}.order-receipt.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        await html2pdf().from(container).set(options).save();
        if (container.parentNode) {
          container.parentNode.removeChild(container);
        }
      } catch (err) {
        this.snackBar = {
          show: true,
          message: err.response ? `Error generating PDF: ${err.response.data.message}` : err.message,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.md-table .md-table-row {
  cursor: pointer;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.table-body {
  overflow-x: auto;
  scroll-behavior: auto;
}

.md-dialog /deep/.md-dialog-container {
  // max-width: 100%;
  min-width: 30%;
}

.body {
  max-width: 100%;
}
</style>
